import {useMemo} from 'react';

import useIsBannerEnabled from '@/hooks/useIsBannerEnabled';

export const useDynamicMobileHighlights = (highlights) => {
    const isBannerEnabled = useIsBannerEnabled();

    return useMemo(() => {
        if (!highlights?.length) return;

        return highlights.filter((highlight) => isBannerEnabled(highlight?.banner));
    }, [highlights, isBannerEnabled]);
};
